import AiFillStar from '../icons/AiFillStar';
import { ProgressBar } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';
import StarRating from './StarRating';
import '../styles/ProductReviewsSummary.css';


/**
 * Displays a summary of ratings for product reviews.
 * @component
 */
const ProductReviewsSummary = ({
    averageRating,
    reviewsPerRating,
    totalReviews,
}) => (<>
    {totalReviews > 0 && <div
        className={'reviews-summary--container'}>
        <div
            className={'reviews-summary--overall'}>
            <div
                className={'reviews-summary--average'}>
                {averageRating.toFixed(1)}
            </div>
            <div>
                <StarRating
                    rating={averageRating}
                    size={'2rem'}
                />
            </div>
            <div
                className={'reviews-summary--title'}>
                OVERALL STAR <wbr />RATING
            </div>
        </div>
        <div
            className={'reviews-summary--details'}>
            {reviewsPerRating
                .sort((a, b) => b.starsRating - a.starsRating)
                .map((rpp) => {
                    const percentage = rpp.reviewCount / Math.max(1, totalReviews) * 100;
                    return <>
                        <div>
                            {rpp.starsRating}
                            <AiFillStar
                                size={'1rem'}
                                color={'black'}
                            />
                        </div>
                        <ProgressBar
                            now={percentage}
                        />
                        <div><strong>{rpp.reviewCount}</strong></div>
                        <div>({percentage.toFixed(2)}%)</div>
                    </>;
                })
            }
        </div>
    </div>}
</>);

/** Prop Types */
ProductReviewsSummary.propTypes = {
    /** The average rating for the product. */
    averageRating: PropTypes.number,
    /** The data regarding the reviews. */
    reviewsPerRating: PropTypes.arrayOf(PropTypes.shape({
        /** The rating represented by the number of stars. */
        starsRating: PropTypes.number.isRequired,
        /** The number of reviews that has the rating. */
        reviewCount: PropTypes.number.isRequired,
    })),
    /** The total number of reviews. */
    totalReviews: PropTypes.number,
};

/** Default Prop Values */
ProductReviewsSummary.defaultProps = {
    averageRating: 0,
    reviewsPerRating: [{
        starsRating: 1,
        reviewCount: 0,
    }, {
        starsrating: 2,
        reviewcount: 0,
    }, {
        starsrating: 3,
        reviewcount: 0,
    }, {
        starsrating: 4,
        reviewcount: 0,
    }, {
        starsrating: 5,
        reviewcount: 0,
    }],
    totalReviews: 0,
};

export default ProductReviewsSummary;
